import React from 'react';
import { Alert, Box, Chip, Typography } from '@mui/material';
import { useUnifiedTranslation } from '../../hooks/useUnifiedTranslation';
import OrganizerDashboard from './OrganizerDashboard';

/**
 * CoOrganizerDashboard - дашборд соорганизатора
 * Использует тот же функционал что и OrganizerDashboard,
 * так как на бэкенде CO_ORGANIZER имеет доступ ко всем эндпоинтам ORGANIZER
 */
export const CoOrganizerDashboard: React.FC = () => {
  const { t } = useUnifiedTranslation({ namespace: 'dashboard' });
  const ts = (key: string, fallback: string) => (typeof t(key) === 'string' ? t(key) : fallback) as string;

  return (
    <Box>
      {/* Индикатор роли соорганизатора */}
      <Box sx={{ p: 3, pb: 0 }}>
        <Alert severity="info" sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip label="CO-ORGANIZER" color="secondary" size="small" />
            <Typography variant="body2">
              {ts('coOrganizer.notice', 'Вы работаете как соорганизатор события с полными правами управления')}
            </Typography>
          </Box>
        </Alert>
      </Box>

      {/* Используем существующий OrganizerDashboard */}
      <OrganizerDashboard />
    </Box>
  );
};

export default CoOrganizerDashboard;

